(function ($) {
	'use strict';

	var MkUi = window.MkUi || {};

	MkUi.confirm = function (message, options) {
		options = options || {};
		var deferred = $.Deferred();
		var confirmText = options.confirmText || 'Confirm';
		var cancelText = options.cancelText || 'Cancel';
		var title = options.title || 'Please confirm';

		var content = '<p class="mk-ui-modal__message">' +
			MkUi.escapeHtml(message) + '</p>';

		MkUi.modal.open(title, content, {
			width: options.width || 400,
		});

		var $actions = $('<div></div>');
		var $cancel = $('<button type="button" class="mk-ui-btn mk-ui-btn--secondary"></button>').text(cancelText);
		var $confirm = $('<button type="button" class="mk-ui-btn mk-ui-btn--primary"></button>').text(confirmText);

		$cancel.on('click', function () {
			MkUi.modal.close();
			deferred.resolve(false);
		});
		$confirm.on('click', function () {
			MkUi.modal.close();
			deferred.resolve(true);
		});

		$actions.append($cancel).append($confirm);
		MkUi.modal.setActions($actions);

		return deferred;
	};

	window.MkUi = MkUi;
})(jQuery);
